import PropTypes from "prop-types";

import useUserStore from "../../store/User.store";
import { useLocation, Navigate } from "react-router-dom";

const RequireAuth = ({ children, checkIsAdmin }) => {
  const user = useUserStore((state) => state.data.user);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (checkIsAdmin && user?.role !== "admin") {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return children;
};

RequireAuth.propTypes = {
  children: PropTypes.element.isRequired,
  checkIsAdmin: PropTypes.bool,
};

RequireAuth.defaultProps = {
  checkIsAdmin: false,
};

export default RequireAuth;
